import React from 'react';

// Import styles
import { BgGradient, AvailableBoxStyled, IconTickStyled } from './styles';

const AvailableIndication = () => (
	<AvailableBoxStyled>
		<IconTickStyled />
		<BgGradient />
	</AvailableBoxStyled>
);

export default AvailableIndication;
